<template>
	<div class="modal">
		<barred-cli-edit-modal
			v-if="editModal"
			:edit-item="selectedBarredCli"
			@update="itemUpdated"
			@save="itemAdded"
			@close="editModal = false"
		/>
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12 w-full">
				<p class="textGrey textLg textCenter">Blocked CLI List</p>
			</div>
		</div>

		<div class="row margin-b30">
			<div class="w-full">
				<div class="card formPanel">
					<div class="content">
						<p class="textCenter margin-b20 mx-auto">
							Total Blocked CLIs:<strong class="margin-l5">{{ barredCliList?.length || '0' }}</strong>
						</p>
						<div class="row">
							<div class="row hideTablet mx-auto mt-6 w-full px-2">
								<div class="w-full">
									<div class="text-xs font-black uppercase text-gray-400">
										<div class="flex w-full">
											<div class="basis-[20%] xl:basis-2/12">
												<p>Number</p>
											</div>
											<div class="basis-[20%] xl:basis-2/12">
												<p>Created</p>
											</div>
											<div class="basis-[20%] xl:basis-2/12">
												<p>Updated</p>
											</div>
											<div class="basis-[20%] xl:basis-2/12">
												<p>User</p>
											</div>
											<div class="basis-[20%] xl:basis-4/12">
												<p>Description</p>
											</div>
											<div class="flex basis-[7%] justify-end xl:basis-1/12">
												<ul class="stepBtns">
													<li>
														<button class="fab fabSm green h-7 w-7" @click="createCliEntry">
															<span class="fa-light fa-plus"></span>
														</button>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row mx-auto my-5 w-full px-2">
								<div v-if="barredCliList.length > 0" class="w-full">
									<div
										v-for="(cli, i) in barredCliList"
										:key="i"
										class="mb-8 grid w-full grid-cols-2 md:mb-2 md:flex md:flex-row"
									>
										<div class="w-full basis-[20%] xl:basis-2/12">
											<p class="text-[12px] font-semibold uppercase text-gray-500 md:hidden">
												Number:
											</p>
											<div class="formGroup">
												<p class="font-bold">{{ cli.number }}</p>
											</div>
										</div>
										<div class="basis-[20%] xl:basis-2/12">
											<p class="text-[12px] font-semibold uppercase text-gray-500 md:hidden">
												Created At:
											</p>
											<div class="formGroup">
												<p>{{ $global.dateTimeFormat(cli.createdAt) }}</p>
											</div>
										</div>
										<div class="basis-[20%] xl:basis-2/12">
											<p class="text-[12px] font-semibold uppercase text-gray-500 md:hidden">
												Updated At At:
											</p>
											<div class="formGroup">
												<p>{{ $global.dateTimeFormat(cli.updatedAt) }}</p>
											</div>
										</div>
										<div class="basis-[20%] xl:basis-2/12">
											<p class="text-[12px] font-semibold uppercase text-gray-500 md:hidden">
												User:
											</p>
											<div class="formGroup">
												<p>{{ cli.user?.name || cli.user?.email || cli.user?.sub }}</p>
											</div>
										</div>
										<div class="basis-[20%] xl:basis-4/12">
											<p class="text-[12px] font-semibold uppercase text-gray-500 md:hidden">
												Description:
											</p>
											<div class="formGroup">
												<p>{{ cli.description }}</p>
											</div>
										</div>
										<div class="flex basis-[7%] gap-2 xl:basis-1/12">
											<button class="fab fabSm blue h-7 w-7" @click="editCli(i)">
												<span class="fa-light fa-pencil"></span>
											</button>
											<button
												v-if="barredCliList.length > 0"
												class="fab fabSm red h-7 w-7"
												@click="removeItem(i)"
											>
												<span class="fa-light fa-minus"></span>
											</button>
										</div>
									</div>
								</div>
								<div v-else class="flex w-full flex-col gap-2">
									<div class="flex w-full justify-center">
										<p class="text-center font-semibold">
											There are no blocked CLIs for this {{ account ? 'account' : 'tenant' }}.
										</p>
									</div>
								</div>
								<div class="relative flex w-full items-center py-5">
									<div class="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
									<button
										class="flex-shrink rounded-sm border border-gray-200 px-4 py-1.5 text-gray-600 hover:bg-gray-200 dark:border-gray-500 dark:text-gray-200 dark:hover:bg-gray-500"
										@click="createCliEntry"
									>
										<span class="fa-light fa-plus"></span>
										Add New
									</button>
									<div class="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12 mx-auto">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg green" @click="save()">Save</a></li>
					<li><a class="jmiBtn btnLg red" @click="close()">Cancel</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['user', 'userRoles', 'showBlockedListModal'],
	props: ['tenant', 'account'],

	data() {
		return {
			editModal: false,
			selectedBarredCli: null,
			barredCliList: [],
			currentlyEditedId: null
		}
	},

	created() {
		this.barredCliList =
			(this.account
				? JSON.parse(JSON.stringify(this.account.barredCliList))
				: JSON.parse(JSON.stringify(this.tenant.barredCliList))) || []
	},

	methods: {
		save() {
			this.$emit('save', this.barredCliList)
			this.close()
		},
		close() {
			this.showBlockedListModal = false
		},
		createCliEntry() {
			this.selectedBarredCli = null
			this.editModal = true
		},
		editCli(i) {
			this.selectedBarredCli = this.barredCliList[i]
			this.currentlyEditedId = i
			this.editModal = true
		},
		removeItem(i) {
			this.barredCliList.splice(i, 1)
		},
		itemAdded(item) {
			this.barredCliList.push(item)
			this.editModal = false
			this.selectedBarredCli = null
		},
		itemUpdated(item) {
			this.barredCliList[this.currentlyEditedId] = item
			this.editModal = false
			this.selectedBarredCli = null
		}
	}
}
</script>
